import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    navDestination: "",
    navPath: "",
    action: "",
    listener: ""
  }
};
const navSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    requestNav: (state, action) => {
      console.log(action);
      state.value = {
        navDestination: action.payload.navDestination,
        navPath: action.payload.navPath,
        action: "requestNav",
        listener: state.value.listener
      };
    },
    listenNav: (state, action) => {
      console.log(action);
      state.value = {
        navDestination: "",
        navPath: "",
        action: "listen",
        listener: action.payload
      };
    },
    resetNav: (state) => {
      state.value = {
        navDestination: "",
        navPath: "",
        action: "",
        listener: ""
      };
    }
  }
});
export const { requestNav, listenNav, resetNav } = navSlice.actions;
export default navSlice.reducer;
